import { useState } from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import Eye from 'components/assets/icons/Eye'
import EyeClosed from 'components/assets/icons/EyeClosed'
import LoginLayout from './LoginLayout'
import style from './LoginLayout.module.scss'

// Formulaire du nouveau design de connexion, partagé par l'espace client et le reporting.
// La logique (react-hook-form, appel API, navigation) reste dans la page appelante.
const LoginForm = ({ register, onSubmit, isValid, loading, errorLabel, forgotTo, signUpTo }) => {
  const { t } = useTranslation()
  const [isPasswordShown, setIsPasswordShown] = useState(false)

  return (
    <LoginLayout
      title={t('common:loginNew.title', 'Votre espace assurance')}
      subtitle={t('common:loginNew.subtitle', 'Connectez-vous pour suivre vos contrats et vos sinistres.')}
    >
      {errorLabel && <div className={style.error} role="alert">{errorLabel}</div>}

      <form onSubmit={onSubmit} noValidate>
        <div className={style.field}>
          <label htmlFor="login-email">Email</label>
          <input
            id="login-email"
            type="email"
            autoComplete="email"
            placeholder={t('common:loginNew.emailPlaceholder', 'Votre adresse email')}
            {...register('email', { required: true })}
          />
        </div>

        <div className={style.field}>
          <label htmlFor="login-password">{t('main:auth.password.password')}</label>
          <div className={style.password}>
            <input
              id="login-password"
              type={isPasswordShown ? 'text' : 'password'}
              autoComplete="current-password"
              placeholder={t('main:auth.password.placeholder')}
              {...register('password', { required: true })}
            />
            <button type="button" className={style.eye} onClick={() => setIsPasswordShown(!isPasswordShown)} aria-label="toggle password">
              {isPasswordShown ? <EyeClosed /> : <Eye />}
            </button>
          </div>
        </div>

        <Link className={style.forgot} to={forgotTo}>{t('main:auth.signIn.forgotPassword')}</Link>

        <button type="submit" className={style.submit} disabled={!isValid || loading}>
          {loading ? '…' : t('main:auth.signIn.login')}
        </button>
      </form>

      <p className={style.alt}>
        {t('common:loginNew.noAccount', 'Pas encore de compte ?')}{' '}
        <Link className={style.link} to={signUpTo}>{t('common:loginNew.createAccount', 'Créer un compte')}</Link>
      </p>
    </LoginLayout>
  )
}

export default LoginForm
